      document.addEventListener("DOMContentLoaded", function() {
        function addVariantListener(selector, delay) {
          document.querySelectorAll(selector).forEach(function(container) {
            if (container.getAttribute("data-abra-listener")) {
              return;
            }
            
            container.querySelectorAll(".swatch-element").forEach(function(button) {
              button.addEventListener("click", function() {
                var variantId = button.querySelector("input[data-variant-id]")?.getAttribute("data-variant-id");
    
                if (!variantId) {
                  return;
                }
    
                container.setAttribute("data-variant-id", variantId);
                window.Abra.render();
                if (delay) {
                  setTimeout(function() {
                    window.Abra.render();
                  }, delay);
                }
              });
  
              container.setAttribute("data-abra-listener", "true");
            });
          });
        }
        
        //#! Featured product
        addVariantListener(".container.product--featured-product");
  
        //#! Quick view
        var quickViewDiv = document.querySelector('div[data-quick-view-content]');
        var abraPopup = document.querySelector('abra-popup');
        new MutationObserver((mutationsList, observer) => {
            for (var mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    if (mutation.addedNodes.length > 0) {
                        // Quick view is opened
                        addVariantListener("#quickViewSlideoutWrapper", 300);
                        window.Abra.render();
                        if (abraPopup) {
                            abraPopup.style.display = 'none';
                        }
                    } else if (mutation.removedNodes.length > 0 && quickViewDiv.children.length === 0) {
                        // Quick view is closed
                        if (abraPopup) {
                            abraPopup.style.display = 'flex';
                        }
                    }
                }
            }
        }).observe(quickViewDiv, {
            childList: true,
            subtree: false,
        });
      });